import { render, staticRenderFns } from "./CharityManagementMixin.vue?vue&type=template&id=190e74d8&scoped=true&lang=html&"
import script from "./CharityManagementMixin.vue?vue&type=script&lang=js&"
export * from "./CharityManagementMixin.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/charity.css?vue&type=style&index=0&id=190e74d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e74d8",
  null
  
)

export default component.exports